import React from 'react'

import Layout from '../layouts/zh'
import SEO from '../components/seo'

import Bubble from '../components/Bubble'
import IntroBox from '../components/IntroBox'
import IllustrationBox from '../components/IllustrationBox'
import Testimonial from '../components/Testimonial'

import FlickitySlider from '../components/FlickitySlider'

import VocationalTraineeesTables from '../components/VocationalTraineeesTables'
import OccupationalAssessmentCandidateTable from '../components/OccupationalAssessmentCandidateTable'

//  Data
const HotelTeamMembers = require('../data/HotelTeamMembers')

const IndexPage = (props) => (
  <Layout location={props.location}>
    <SEO title="旅業及酒店業學校" />

    <div
      className="bg-banner-30 bg-center bg-cover"
      style={{ backgroundImage: `url(/AnnualReport2017-2018/images/bg-hotel.jpg)`, minHeight: '200px' }}
      id="onward-to-success"
    >
      <div className="absolute inset-0 py-12">
        <div className="container" data-aos="fade-up" data-aos-delay={400} data-aos-duration={1200}>
          <Bubble className="w-full md:w-1/2"
            title="專業續寫成功"
            subtitle=""
          >
          </Bubble>
        </div>
      </div>
    </div>

    <div className="py-8 md:py-12">
      <div className="container">
        <div className="flex flex-row flex-wrap mt-8">
          <div className="w-full lg:w-1/3">
            <div className="inset-0" data-aos="fade-right">
              <img src="/AnnualReport2017-2018/images/hotel/7.1.2.jpg" alt="IFT" className="object-cover object-bottom h-full w-full shadow-xl rounded-sm" />
            </div>
          </div>
          <div className="w-full lg:w-2/3 flex" data-aos="fade-left">
            <div className="text-left mx-auto text-sm lg:text-base lg:pl-8 font-normal mt-4 lg:mt-0 text-justify">
              <p className="mb-4">旅遊學院旅業及酒店業學校提供優質的專業課程，助有意投身旅遊及服務業的學生汲取知識及發揮才能。20多年來，學院與時俱進，配合市場需求，開辦國際認證課程，並廣受好評。</p>
              <p className="mb-4">課程因應不同程度分為基礎、進階及高階，每年吸引約20,000人次參與課程及認證考核。旅業及酒店業學校亦與多間海內外國際認證機構合辦全球旅遊及服務業界認可的證書及認證課程，頗受國內外旅遊和酒店業界的廣泛認可。</p>
              <p className="mb-4">旅業及酒店業學校一直秉承專業成就卓越的理念，與教育暨青年局合辦兩個三年制的職業技術高中課程，包括旅遊技術課程和平面設計課程。此兩項課程由高中學科及專業學科組成，並輔以實習計劃。學校還為高中學生設立語言課程和職前技能培訓課程，教授學生對酒店業、飲食業及會展業的知識，啟蒙未來職業選擇。</p>
              <p className="mb-4">為鼓勵終身學習，旅遊學院為居民提供多項免費基礎培訓課程。除了向公眾提供課程外，亦計劃與本地社團及業界夥伴合作提供培訓項目。</p>
              <p>旅業及酒店業學校每年舉辦各種餐飲業務和文化旅遊研討會和工作坊，並與海外合作夥伴合作舉辦不同活動，拓寬與會人士的國際視野及增長見識。</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="bg-gray-200 py-8 md:py-12" id="eight-major-area">
      <div className="container mb-12">
        <h2 className="text-3xl md:text-5xl text-orange-500 text-center mb-2" data-aos="fade-down">八大領域</h2>
        <div className="flex flex-row flex-wrap mt-8">
          <div className="w-full flex">
            <div className="text-left mx-auto text-sm md:text-base max-w-xl font-normal text-justify" data-aos="fade-up">
              <p>為了全力支持澳門經濟多元化發展，促進本地員工向上流動。旅遊學院旅業及酒店業學校提供八個主要領域相關的課程，包括酒店；餐飲；文化遺產及旅遊；零售、會展及商業；創意藝術及資訊科技；健康、美容及美療；語言文化；自我提升。</p>
            </div>
          </div>
        </div>
      </div>

      <div
        className="bg-banner-30 bg-center bg-cover"
        style={{ backgroundImage: `url(/AnnualReport2017-2018/images/hotel/7.1.1.jpg)` }}
      >
      </div>

      <div className="container mt-12">
        <div className="flex flex-wrap">
          <div className="w-full md:w-1/2 md:pr-4" data-aos="zoom-out">
            <h4 className="text-xl md:text-2xl text-indigo-700 mb-2">酒店</h4>
            <div className="text-left mx-auto text-sm md:text-base font-normal text-justify">
              <p>課程的覆蓋面廣，包括行業技能操作以至管理概念。另外，通過與國際培訓機構的合作，開辦不同類型的國際證書課程，幫助學員考取認證，為事業生涯打下堅實的基礎。</p>
            </div>
          </div>
          <div className="w-full md:w-1/2 md:pl-4 mt-12 md:mt-0" data-aos="zoom-out" data-aos-delay={150}>
            <h4 className="text-xl md:text-2xl text-indigo-700 mb-2">餐飲</h4>
            <div className="text-left mx-auto text-sm md:text-base font-normal text-justify">
              <p>致力為餐飲業界和社區提供不同程度的相關專業培訓。課程範圍包括餐飲管理、餐廳前線服務、酒吧運作、烹飪廚藝和食物飲料知識。此外，學院與多間國際培訓機構合作，如法國巴黎Ferrandi、法國藍帶廚藝學院、精品咖啡協會、葡萄牙葡萄酒學校等。澳門獲聯合國教科文組織評定為“創意城市美食之都”，將持續開發更多傳承本地傳統烹飪廚藝的課程。</p>
            </div>
          </div>
        </div>
        <div className="flex flex-wrap mt-12">
          <div className="w-full md:w-1/2 md:pr-4" data-aos="zoom-out">
            <h4 className="text-xl md:text-2xl text-indigo-700 mb-2">文化遺產及旅遊</h4>
            <div className="text-left mx-auto text-sm md:text-base font-normal text-justify">
              <p>提供多項文化遺產及旅遊課程，以培養業界棟樑。課程包括有多種語言的導遊課程、世界文化遺產導賞員和澳門文化導遊課程，以及為培養旅行社人員成為旅行社主管而設的旅行社督導課程。此外，與國際航空運輸協會合作，定期開辦國際旅遊代理基礎課程，同時定期舉行對公眾開放的文化旅遊講座。</p>
            </div>
          </div>
          <div className="w-full md:w-1/2 md:pl-4 mt-12 md:mt-0" data-aos="zoom-out" data-aos-delay={150}>
            <h4 className="text-xl md:text-2xl text-indigo-700 mb-2">零售、會展及商業</h4>
            <div className="text-left mx-auto text-sm md:text-base font-normal text-justify">
              <p>零售、會展及商業團隊設有一系列銷售技巧、店舖運作、市場推廣及視覺營銷課程，以配合零售行業的急速發展；與此同時，我們更設有從入門至管理程度的財務管理、會計以及商業管理課程；而對會展行業有興趣的人士可選擇婚禮活動策劃或公共關係的各式課程。</p>
            </div>
          </div>
        </div>
        <div className="flex flex-wrap mt-12">
          <div className="w-full md:w-1/2 md:pr-4" data-aos="zoom-out">
            <h4 className="text-xl md:text-2xl text-indigo-700 mb-2">創意藝術及資訊科技</h4>
            <div className="text-left mx-auto text-sm md:text-base font-normal text-justify">
              <p>為配合文化創意產業與智慧城市的發展，旅業及酒店業學校開辦多個創意藝術及資訊科技課程。提供的課程多元及廣泛，當中覆蓋藝術及設計訓練、資訊學習、以及創意思维發展等範疇。</p>
            </div>
          </div>
          <div className="w-full md:w-1/2 md:pl-4 mt-12 md:mt-0" data-aos="zoom-out" data-aos-delay={150}>
            <h4 className="text-xl md:text-2xl text-indigo-700 mb-2">健康、美容及美療</h4>
            <div className="text-left mx-auto text-sm md:text-base font-normal text-justify">
              <p>通過與國際培訓機構合作，開辦不同類型的認證課程，其中更具有專業導師資格，有助學員及早做好職業規劃及發展。學員的一些熱門選擇包括健身教練、瑜伽導師、專業化妝、食品安全及營養學課程。新開展的普拉提蓆上導師課程及運動手法按摩專教練課程亦深受喜愛。</p>
            </div>
          </div>
        </div>
        <div className="flex flex-wrap mt-12 mb-8">
          <div className="w-full md:w-1/2 md:pr-4" data-aos="zoom-out">
            <h4 className="text-xl md:text-2xl text-indigo-700 mb-2">語言文化</h4>
            <div className="text-left mx-auto text-sm md:text-base font-normal text-justify">
              <p>為提升市民的語言能力，旅業及酒店業學校提供多元化的語言課程，包括英語、葡萄牙語、普通話、廣東話、日語、韓語及法語課程。課程分不同程度，適合初學及近乎母语水平能力的人士報讀。此外，學院的導師也為從事酒店、餐飲及零售等服務行業的學員設計合適的課程，以及為本地高中學生設計一系列職前技能培訓課程。</p>
            </div>
          </div>
          <div className="w-full md:w-1/2 md:pl-4 mt-12 md:mt-0" data-aos="zoom-out" data-aos-delay={150}>
            <h4 className="text-xl md:text-2xl text-indigo-700 mb-2">自我提升</h4>
            <div className="text-left mx-auto text-sm md:text-base font-normal text-justify">
              <p>學院亦專門設置自我提升課程，培訓內容包括人際關係、溝通技巧、公關禮儀及前線人員人際關係，有助學員自如應對工作和生活中的挑戰。</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="py-8 lg:py-12 md:pb-0">
      <div className="container flex flex-wrap">
        <div className="flex mt-8 w-full lg:w-1/2" data-aos="zoom-in">
          <Testimonial
            title="旅業及酒店業學校提供以下範疇的專業培訓課程："
            color="blue"
            className="w-full"
          >
            <ul className="list-disc">
              <li>酒店</li>
              <li>餐飲</li>
              <li>文化遺產及旅遊</li>
              <li>零售、會展及商業 </li>
              <li>創意藝術及資訊科技</li>
              <li>健康、美容及美療</li>
              <li>語言文化</li>
              <li>自我提升</li>
            </ul>
          </Testimonial>
        </div>
        <div className="flex mt-8 w-full lg:w-1/2 lg:pl-12" data-aos="flip-down">
          <div className="inset-0">
            <img src="/AnnualReport2017-2018/images/hotel/Restaurant-1.jpg" alt="IFT" className="object-cover object-bottom h-full w-full shadow-xl rounded-sm" />
          </div>
        </div>
      </div>
    </div>

    <div className="py-8 md:pb-24">
      <div className="container flex flex-wrap">
        <div className="flex mt-8 w-full lg:w-1/2" data-aos="flip-down">
          <div className="inset-0">
            <img src="/AnnualReport2017-2018/images/hotel/7.1.3.jpg" alt="IFT" className="object-cover object-bottom h-full w-full shadow-xl rounded-sm" />
          </div>
        </div>
        <div className="flex mt-8 w-full lg:w-1/2 lg:pl-12" data-aos="zoom-in">
          <Testimonial
            title="終身學習"
            color="orange"
          >
            <p className="mb-4">作為立足本土並具高瞻遠矚的教育機構，旅業及酒店業學校以發展性及全局性的眼光，將鼓勵終身學習作為核心使命。為進一步完善教育，為澳門居民提供多元化的培訓計劃，旅業及酒店業學校自2008學年開始加入由教育暨青年局推出的“持續教育資助計劃”教育網絡，以實際行動推廣終身學習。2011年，該計劃被“持續進修發展計劃”所代替。</p>
            <p>截至2018年8月，學院有大約1,670 個課程獲得批准，約16,292名居民受惠。於2017/18學年，學院有大約290個課程獲得批准，約2,558人次受惠。</p>
          </Testimonial>
        </div>
      </div>
    </div>

    <div className="bg-gray-200 py-12">
      <div className="container">
        <div data-aos="fade-up">
          <VocationalTraineeesTables
            langKey={props.pageContext.langKey}
            className="mb-12"
          />
        </div>

        <div data-aos="fade-up">
          <OccupationalAssessmentCandidateTable
            langKey={props.pageContext.langKey}
          />
        </div>
      </div>
    </div>

    <div
      className="bg-banner-30 bg-center bg-cover py-12"
      style={{ backgroundImage: `url(/AnnualReport2017-2018/images/hotel/7.2.1.jpg)` }}
    >
    </div>

    <div className="py-8 md:py-12 md:pb-24" id="our-professional-training-staff">
      <div className="container">
        <h2 className="text-3xl md:text-5xl text-orange-500 text-center mb-2" data-aos="fade-down">我們的專業導師</h2>
        <div className="w-full md:w-1/2 mx-auto my-12 text-center" data-aos="fade-up">
          <h4 className="text-xl md:text-2xl text-indigo-700 mb-2">課程主任</h4>
          <div className="mx-auto max-w-xl text-left text-sm md:text-base font-normal text-justify">
            <p>旅遊學院旅業及酒店業學校的課程主任具備專業資格和經驗，協助學員在個人發展與職場上取得成功。他們制定及執行全面且具系統性的教學計劃，為學員創造更多機會，讓他們在各領域中取得成功。</p>
          </div>
        </div>

        <FlickitySlider>
          {
            HotelTeamMembers.map((member, i) => (
              <div key={i} className="w-full md:w-1/4 mb-12 text-center">
                <div className="flex flex-col items-center mx-4">
                  <img src={`/AnnualReport2017-2018${member.image}`} alt="member" className="rounded-full w-40 h-40 mb-2" />

                  <div className="w-full text-2xl text-blue-500">
                    { member.name['zh'] }
                  </div>
                  <div className="w-full mb-2">
                    { member.title['zh'] }
                  </div>
                  <div className="w-full text-sm font-normal text-left text-justify">
                    { member.description['zh'] }
                  </div>
                </div>
              </div>
            ))
          }
        </FlickitySlider>

      </div>
    </div>

    <div
      className="bg-banner-30 bg-center bg-cover py-12"
      style={{ backgroundImage: `url(/AnnualReport2017-2018/images/hotel/7.3.1.jpg)` }}
    >
    </div>

    <div className="bg-gray-200 py-8 md:py-12">
      <div className="container">
        <h2 className="text-3xl md:text-5xl text-orange-500 text-center mb-2" data-aos="fade-down">技能測試</h2>
        <div className="flex flex-row flex-wrap mt-8">
          <div className="w-full md:w-2/3 flex" data-aos="fade-right">
            <div className="text-left mx-auto text-sm md:text-base md:pr-8 font-normal text-justify">
              <p className="mb-4">旅業及酒店業學校一直致力投入澳門職業技能認可基準的工作，基準由旅遊學院與澳門旅遊同業共同努力制定，建立了一系列工種的培訓機制並且進行評核。</p>
              <p className="mb-4">設立澳門職業技能認可基準的主要目的是透過引入一系列工種的認可制度，提升澳門旅遊業人力資源的質素。從業人員可通過展示工作技能，參與評核，獲得證書。有關證書獲得澳門旅遊業界認可。</p>
              <p className="mb-4">此基準在2001年推出，且得到了歐盟的支持，更獲得亞太旅遊協會（PATA）頒授“教育和培訓”金獎。</p>
              <p className="mb-4">每年至少開辦兩次預備課程和職業技能評核試。為了配合澳門旅遊業和酒店業的快速發展，學院自2010年起為公眾開辦為期較長的預備課程。</p>
              <p>為了表揚於基準工作範疇內傑出表現的人士，旅遊學院自2002年開始舉辦“金襟針比賽”。在2017/18學年，20位參賽者贏得了獎項。</p>
            </div>
          </div>
          <div className="w-full md:w-1/3 mt-12 md:mt-0" data-aos="fade-left">
            <div className="flex flex-col">
              <div className="w-1/4 md:w-1/3 mx-auto">
                <img src="/AnnualReport2017-2018/images/hotel/7.3.2.png" alt="" className="block rounded-full" />
              </div>
              <div className="text-left mx-auto text-sm md:text-base mt-6 text-justify">
                <p className="text-blue-700">“畢竟我們的客人是由一眾前線人員，包括侍應生、房務員、保安及前堂服務員提供服務，他們都為在澳門作出重要貢獻，而澳門職業技能認可基準正見證他們的努力。”</p>
                <p className="mt-4 text-gray-700"><strong>簡博賢</strong><br/>美高梅中國控股有限公司首席執行官</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="py-8 md:py-12">
      <div className="container">
        <div className="flex flex-row flex-wrap">
          <div className="w-full md:w-2/3" data-aos="zoom-out">
            <Testimonial
              title="澳門職業技能認可基準認可的工種包括："
              color="orange"
            >
              <div className="flex flex-wrap">
                <div className="w-full md:w-1/2">
                  <ul className="list-disc">
                    <li>西廚助理廚師</li>
                    <li>調酒員</li>
                    <li>中式烹調師（港澳粵菜） - 初級</li>
                    <li>中式烹調師（港澳粵菜） - 中級</li>
                    <li>中式烹調師（港澳點心） - 初級</li>
                    <li>中式烹調師（港澳點心） - 中級</li>
                    <li>前堂代辦及行李員</li>
                    <li>花藝設計師</li>
                    前堂服務員
                  </ul>
                </div>
                <div className="w-full md:w-1/2">
                  <ul className="list-disc md:pl-8">
                    <li>客務關係主任</li>
                    <li>零售服務主任</li>
                    <li>房務員</li>
                    <li>旅遊博彩業保安員</li>
                    <li>旅行社代理</li>
                    <li>中菜侍應生</li>
                    <li>西餐侍應生</li>
                    <li>西點烘焙師</li>
                  </ul>
                </div>
              </div>
            </Testimonial>
          </div>
          <div className="w-full md:w-1/3 md:pl-8" data-aos="zoom-out">
            <IllustrationBox
              number={1742}
              image="/images/certificate.gif"
              text="在2017/2018學年，參加學院培訓課程並獲得MORS認證"
              className="text-4xl"
              alignment="left"
            />
          </div>
        </div>
      </div>
    </div>

    <div className="bg-gray-200 py-8 md:py-12" id="be-creative">
      <div className="container">
        <h2 className="text-3xl md:text-5xl text-orange-500 text-center mb-2" data-aos="fade-down">創意藝術領軍者</h2>
        <div className="flex flex-row flex-wrap mt-8">
          <div className="w-full lg:w-2/3 flex">
            <div className="text-left mx-auto text-sm lg:text-base lg:pr-8 font-normal text-justify" data-aos="fade-right">
              <p className="mb-4">旅遊學院一直致力推動澳門實現經濟多元化發展，在文化創意方面，也積極配合特區政府政策，旅業及酒店業學校提供多元化的創意藝術課程，冀望提高本地居民的技能。</p>
              <p className="mb-4">旅業及酒店業學校提供不同類型的創意藝術課程，課程內容廣泛，從美術繪畫到影片剪輯，再到皮革工藝製作等。課程亦會分成不同程度及主題，讓學員循序漸進地學習，也可讓他們選擇合適或感興趣的項目針對地進修。 </p>
              <p>旅遊學院投入培養文化產業人才，並成為文化產業委員會成員，為澳門特區政府出謀獻策。旅遊學院旅業及酒店業學校也通過在望廈山校區及南灣．雅文湖畔旅遊學院咖啡廊定期舉辦免費入場的藝術展覽，為澳門的文化藝術事業貢獻力量。</p>
            </div>
          </div>
          <div className="w-full lg:w-1/3 mt-4 lg:mt-0" data-aos="fade-left">
            <div className="inset-0">
              <img src="/AnnualReport2017-2018/images/hotel/7.3.6.jpg" alt="IFT" className="object-cover object-bottom h-full w-full shadow-xl rounded-sm" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="py-8 md:py-12">
      <div className="container">
        <div className="flex flex-row flex-wrap" data-aos="zoom-out">
          <div className="w-full">
            <Testimonial
              title="2017/18學年創意藝術課程："
              color="blue"
            >
              <div className="flex flex-wrap">
                <div className="w-full md:w-1/2">
                  <ul className="list-disc md:pr-6">
                    <li>企業形象設計</li>
                    <li>廣告設計</li>
                    <li>攝影</li>
                    <li>花藝</li>
                    <li>紀念品設計及製作</li>
                    <li>中國及西方繪畫</li>
                  </ul>
                </div>
                <div className="w-full md:w-1/2">
                  <ul className="list-disc">
                    <li>中國書法及古英文書法</li>
                    <li>現代陶瓷藝術</li>
                    <li>皮革工藝</li>
                    <li>DIY環保創作</li>
                    <li>藝術行政</li>
                    <li>視覺藝術市場營銷與管理</li>
                  </ul>
                </div>
              </div>
            </Testimonial>
          </div>
        </div>
      </div>
    </div>

    <div className="bg-gray-200 py-8 md:py-12 md:pb-16" id="the-ift-tourism-and-hotel-school-held-4-art-exhibitions-in-2017-18">
      <div className="container">
        <h4 className="text-2xl md:text-2xl text-blue-600 text-center mb-12" data-aos="fade-down">2017/18學年，旅業及酒店業學校舉辦了四個藝術展覽：</h4>
        <div className="flex flex-wrap">
          <div className="flex w-full lg:w-2/3 flex-wrap">
            <div className="w-full md:w-1/2 md:pr-4" data-aos="zoom-out">
              <h4 className="text-xl md:text-xl text-indigo-700 mb-2">紀實無常</h4>
              <div className="text-left mx-auto text-sm md:text-base">
                <p>郭恬熙師生作品展</p>
                <p className="mt-4 text-gray-600 text-sm">2017年12月15日至2018年3月31日，澳門望廈校區</p>
              </div>
            </div>
            <div className="w-full md:w-1/2 md:pl-4 mt-8 md:mt-0" data-aos="zoom-out" data-aos-delay={150}>
              <h4 className="text-xl md:text-xl text-indigo-700 mb-2">春風創意 II</h4>
              <div className="text-left mx-auto text-sm md:text-base">
                <p>學生作品展</p>
                <p className="mt-4 text-gray-600 text-sm">2018年4月30日至7月31日，澳門望廈校區</p>
              </div>
            </div>
            <div className="w-full md:w-1/2 md:pr-4 mt-8" data-aos="zoom-out">
              <h4 className="text-xl md:text-xl text-indigo-700 mb-2">光合作用 II</h4>
              <div className="text-left mx-auto text-sm md:text-base">
                <p>鄧國豪個人攝影展</p>
                <p className="mt-4 text-gray-600 text-sm">2017年10月6日至12月31日，旅遊學院咖啡廊</p>
              </div>
            </div>
            <div className="w-full md:w-1/2 md:pl-4 mt-8" data-aos="zoom-out" data-aos-delay={150}>
              <h4 className="text-xl md:text-xl text-indigo-700 mb-2">二十小時</h4>
              <div className="text-left mx-auto text-sm md:text-base">
                <p className="mb-4">馬維斯抽象繪畫師生展</p>
                <p className="mt-4 text-gray-600 text-sm">2018年1月12日至3月2日，旅遊學院咖啡廊</p>
              </div>
            </div>
          </div>
          <div className="w-full lg:w-1/3 mt-12 lg:mt-0">
            <div className="inset-0" data-aos="flip-down" data-aos-delay={150}>
              <img src="/AnnualReport2017-2018/images/hotel/7.3.5.jpg" alt="IFT" className="object-cover object-bottom h-full w-full shadow-xl rounded-sm" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      className="bg-banner-30 bg-center bg-cover py-12"
      style={{ backgroundImage: `url(/AnnualReport2017-2018/images/hotel/7.3.4.jpg)` }}
    >
    </div>

    <div className="py-8 md:py-12 md:pb-16" id="together-for-future-success">
      <div className="container">
        <h2 className="text-3xl md:text-5xl text-orange-500 text-center mb-2" data-aos="fade-down">攜手共創未來</h2>
        <div className="mx-auto text-sm md:text-base max-w-xl text-left mt-4 mb-12 font-normal" data-aos="fade-up">
          <p>為了提供高質素的專業培訓課程，旅遊學院旅業及酒店業學校定期與公共及私人機構合作，根據不同需求量身定制培訓課程。</p>
        </div>

        <div className="flex flex-row flex-wrap">
          <div className="w-full md:w-1/2 mb-8 flex" data-aos="fade-right">
            <IntroBox className="mx-2 text-sm md:text-base h-full"
              title="視覺藝術市場營銷與管理"
              image="/images/hotel/Visual-Art.jpg"
            >
              <p className="mb-4">旅業及酒店業學校與澳門文化局合作開辦“藝術行政證書課程”及“表演藝術管理證書課程”，推動本地文化創意產業發展。旨在培養學員的展覽和活動策劃以及組織和管理技能，培育澳門文化創意產業發展所需的人才，促進澳門經濟多元化發展。</p>
              <p>在2017年旅業及酒店業學校與澳門文化局更合作推出“視覺藝術市場營銷與管理課程”，邀請來自澳門、香港及中國內地專家學者任教。177小時的課程涵蓋理論和實踐研究。課程內容包括從營銷、藝術畫廊管理到藝術投資的各種主題。</p>
            </IntroBox>
          </div>
          <div className="w-full md:w-1/2 mb-8 flex" data-aos="fade-left">
            <IntroBox className="mx-2 text-sm md:text-base h-full"
              title="警員禮儀培訓"
              image="/images/hotel/IMG_0492.JPG"
            >
              <p className="mb-4">為配合保安部隊高等學校提出的“優化前線人員服務質素培訓計劃”，旅業及酒店業學校自2015年開始為前線警員提供軟技能培訓，提升前線警員的禮儀及溝通能力，包括外語能力、向旅客傳達澳門文化遺產的相關訊息等。</p>
              <p className="mb-4">計劃的目的是改善警員與旅客之間的交流互動，助力澳門建設世界旅遊休閒中心，最終有助提高警察隊伍的服務質量。</p>
              <p>旅業及酒店業學校與保安部隊高等學校計劃在2020年前，為1,000名警隊前線人員提供培訓，預計每年開辦10期課程，每期學員人數為25人。首期課程於2015年舉辦，目前已培訓了736人次。此外，學院也為澳門海關關員開辦英語課程，提升語言能力。2017/18學年，共開設了4班，培訓150人次。</p>
            </IntroBox>
          </div>
          <div className="w-full md:w-1/2 mb-8 flex" data-aos="fade-right">
            <IntroBox className="mx-2 text-sm md:text-base h-full"
              title="在職培訓"
              image="/images/hotel/IMG_0491.JPG"
            >
              <p className="mb-4">旅業及酒店業學校一直與業界保持密切合作，為僱員提供培訓，致力為他們的職業發展提供無限可能。學校定期與澳門酒店協會合作，開辦各式各樣的基礎、進階及高階課程，包括語言、餐飲及管理等科目。針對企業和機構的個別需求，學院量身定制不同的培訓課程。於2017/18學年，來自32所本地機構共6,390名業界人士參與這些特設課程。</p>
              <p>除此之外，旅業及酒店業學校亦與金沙中國以及新濠博亞娛樂開辦酒店管理課程，為本地業內人士提供進修機會，讓他們把課堂學習的理論概念應用在工作崗位上，有利他們職業晉升。同時，課程亦設有國際考核，讓學員考取國際認證資格。</p>
            </IntroBox>
          </div>
          <div className="w-full md:w-1/2 mb-8 flex" data-aos="fade-left">
            <IntroBox className="mx-2 text-sm md:text-base h-full"
              title="餐飲範疇課程"
              image="/images/hotel/Escalating-F&B-Training.jpg"
            >
              <p className="mb-4">澳門享有“創意城市美食之都”的美譽，作為專業的院校，推廣澳門美食文化及技藝是學院肩負的責任和使命之一。旅業及酒店業學校一直致力提供餐飲範疇課程，在2017/18學年，旅業及酒店業學校提供了約150個短期餐飲專業培訓課程，涵蓋不同領域、程度，滿足不同經驗與背景人士所需，當中包括不同菜系的烹飪技巧、餐飲產品知識、餐飲服務技巧、食物衛生等。2017/18學年培訓人次達2,680。</p>
              <p>餐飲範疇課程也愈趨多元化，包括烹飪文憑課程（麵包及西餅製作文憑課程、西式烹飪技巧文憑課程）、晚間烹飪短期課程（港澳粵菜、港澳點心、葡國菜及澳門菜、西班牙菜、意大利菜、日本菜等）、國際及內地認證課程，國際廚藝大師工作坊，不同主題餐飲相關講座等。</p>
            </IntroBox>
          </div>
          <div className="w-full md:w-1/2 mb-8 flex" data-aos="fade-right">
            <IntroBox className="mx-2 text-sm md:text-base h-full"
              title="捕漁業文化導賞課程"
              image="/images/hotel/Fishing.jpg"
            >
              <p>旅業及酒店業學校與勞工事務局及澳門海港歷史文化協會合作，於2018年6月為漁民開設“傳統捕漁業文化導賞課程”，藉此教授漁民澳門基本資料、歷史、沿岸景點、服務技巧和演說技巧，培訓他們成為“休漁漁家樂”活動中的海上遊導賞員。</p>
            </IntroBox>
          </div>
        </div>
      </div>
    </div>
  </Layout>
)

export default IndexPage
